var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header-menu',{attrs:{"menu-items":_vm.menuItems,"title":_vm.project.name + ' Menu'}})}
var staticRenderFns = []

export { render, staticRenderFns }